(ns practitest.frontend.components.navigation
  (:require
    [ajax.url :as url]
    [clojure.string :as str]
    [goog.object :as gobj]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components.overflow :as overflow]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.events :as events]
    [practitest.frontend.components.tooltip :as tooltip]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.components2.search-box :as search-box]
    [practitest.frontend.common.utils :refer [development-only]]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

;; Both for project-level and dropdowns
(defn menu-item-element [{:keys [text
                                 bold?
                                 read-only?
                                 disabled?
                                 collapsed?
                                 primary?
                                 active?
                                 icon
                                 additional-item
                                 id
                                 test-id

                                 mixpanel
                                 href
                                 new-window?

                                 disabled-tooltip?
                                 disabled-tooltip-text

                                 on-click
                                 offset]
                          :as   props}]
  [tooltip/mux-tooltip
   {:hidden? (and (not disabled-tooltip?)
                  (not collapsed?))
    :offset  offset}
   (if disabled-tooltip?
     disabled-tooltip-text
     text)
   (fn [props]
     [:a.menu-item-element
      (merge props
             (cond-> {:class    (dom/classes-pairs :readonly read-only?
                                                   :primary primary?
                                                   :collapsed collapsed?
                                                   :active active?
                                                   :disabled disabled?)

                      ;; This id is used for keyboard shortcuts - pending refactoring
                      :id id

                      :on-click (fn [e]
                                  (when-not disabled?
                                    (when mixpanel
                                      (apply mixpanel/track mixpanel))
                                    (when on-click
                                      (on-click e))))

                      :href (when-not disabled? href)}

                     true
                     (dom/add-test-id test-id)

                     new-window?
                     (assoc :target "_blank")))

      (when icon
        [:span.icon-holder {:class (when disabled? "disabled")}
         [icon]])

      ;; TODO: transition cycle ?
      (when-not collapsed?
        [overflow/overflow-with-mux-tooltip
         {}
         (fn [props]
           [:div.menu-item-text
            (merge props
                   {:class (dom/classes-pairs :bold bold?)})
            text])
         text])

      additional-item])])

(defn menu-item-separator [{:keys [collapsed? class] :as props}]
  [:div.menu-separator
   {:class (dom/classes-pairs :collapsed collapsed?
                              class (some? class))}])

(defn menu-item-header [{:keys [text icon collapsed?] :as props}]
  [:<>
   [menu-item-element (assoc props
                        :primary? true
                        :bold? true
                        :read-only? true
                        :collapsed? collapsed?)]
   [menu-item-separator props]])

(defn account-menu-item
  [{:keys [text icon active? id href bottom-text]}]
  [tooltip/mux-tooltip
   {:position "right"}
   text
   (fn [props]
     [:a.account-menu-item
      (-> props
          (assoc
            :class (dom/classes-pairs-v :active active?)
            :href href)
          (dom/add-test-id-and-id id))
      [:div.icon
       icon]
      (when bottom-text [:div.text text])])])

(defonce proj-selector-state (reagent/atom {}))

(defn pin-project-span
  [user-project props]
  (let [local-state (reagent/atom {})]
    (fn [user-project props]
      (let [pinned?                (:is_pinned user-project)
            on-project-pin-clicked (:on-project-pin-clicked props)]
        [tooltip/mux-tooltip
         {:on-toggle (fn [new-value]
                       (swap! local-state assoc :show-tooltip? new-value))
          :show?     (:show-tooltip? @local-state)}
         (if pinned?
           (get-translation "navigation.project-menu.unpin-project" "Unpin Project")
           (get-translation "navigation.project-menu.pin-project" "Pin Project"))
         (fn [props]
           [:span.pin-holder
            (assoc props
              :on-click (fn [e]
                          (dom/stop-propagation e)
                          ;; Do not navigate when clicked on pin
                          (dom/prevent-default e)
                          ;; Hide tooltip after user has clicked on it
                          ;; Otherwise there's an annoying effect when clicking Pin/Unpin
                          (swap! local-state assoc :show-tooltip? false)

                          (when on-project-pin-clicked
                            ;; TODO: in events handler / interceptor chain ?
                            (mixpanel/track "Pin Project")
                            (on-project-pin-clicked user-project))))
            (if pinned?
              [icons/mux-pin-filled-primary]
              [icons/mux-pin-outline])])]))))

(defn project-icon [project]
  [:span.project-icon
   [:div.project-icon-background]
   (if-let [logo-url (:logo_url project)]
     [:img {:src logo-url}]
     [icons/mux-default-project-icon])])

;; TODO: refactor with selector2 component
(defn project-selector [props]
  (let [selector-state (reagent/atom {})
        input-ref (atom nil)]
    (fn [{:keys [current-project
                 current-account
                 user-projects
                 webcomponent?]
          :as   props}]
      (let [show?   (:show? @selector-state)
            hide!   (fn []
                      (swap! selector-state assoc :show? false))
            toggle! (fn []
                      (let [new-show? (:show? (swap! selector-state update :show? not))]
                        (when new-show?
                          (dom/focus-on-ref! input-ref false))))]
        [overlay2/floating-ui-overlay
         {:placement        "bottom"
          :show?            show?
          :target-width?    true
          :on-request-close hide!}

         ;; Target
         [:div.project-selector
          {:class    (dom/classes-pairs :webcomponent webcomponent?)
           :on-click (fn [e]
                       (toggle!))}

          [:div.project-selector-selection
           {:class (dom/classes-pairs :expanded show?)}
           [project-icon current-project]
           [overflow/overflow-with-mux-tooltip
            ;; There's no space on top for this
            {:position "bottom"}
            (fn [props]
              [:span.project-name
               props
               (:name current-project)])
            (:name current-project)]

           [:span.dropdown-chevron
            [:span.icon-holder
             [icons/mux-chevron-down]]]]]

         ;; Dropdown body
         (let [user-projects (filter #(= (:account_id (:project %))
                                         (:id current-account))
                                     user-projects)
               filter-value  (:filter-value @selector-state)
               has-filter?   (not (str/blank? filter-value))]
           [:div.project-selector-dropdown
            {:on-click (fn [e]
                         ;; Presvent clicks inside dropdown from closing overlay (in shadow DOM mode)
                         (dom/stop-propagation e))}
            [search-box/search-textbox
             {:class :project-selector-search
              :ref input-ref
              :placeholder (get-translation "navigation.project-selector.search-placeholder" "Search")
              :value filter-value
              :on-change (fn [e]
                           (swap! selector-state assoc :filter-value (dom/event-value e)))}]

            [:div.project-selector-items-container
             (for [user-project (->> user-projects
                                     ;; Only show current account's projects here
                                     (filter #(if has-filter?
                                                (fu/substring-search? (:name (:project %)) filter-value)
                                                true))
                                     (sort (fn [x y]
                                             (cond
                                               (and (:is_pinned x)
                                                    (:is_pinned y))
                                               (compare (:name (:project x))
                                                        (:name (:project y)))

                                               (:is_pinned x)
                                               -1

                                               (:is_pinned y)
                                               1

                                               :else
                                               (compare (:name (:project x))
                                                        (:name (:project y)))))))
                   :let [project  (:project user-project)
                         current? (= (:id project)
                                     (:id current-project))]]
               (let [href (broutes/get-url "sessions#change_project" {} {:project_id (:id project)})]
                 ^{:key (:id project)}
                 [:a.project-selector-item
                  {:class    (dom/classes-pairs :active current?)
                   :href     href
                   :on-click (fn [e]
                               (mixpanel/track "Switch Project"))}

                  ;; Pin project icon
                  [pin-project-span user-project props]
                  [project-icon project]
                  [overflow/overflow-with-mux-tooltip
                   {}
                   (fn [props]
                     [:span.project-name
                      props
                      (:name project)])
                   (:name project)]
                  (when current?
                    [:span.icon-holder
                     [icons/mux-checkbox]])]))]])]))))

;; Different styles
(defn user-avatar2
  [user]
  (when-let [avatar (:avatar user)]
    [:div.avatar-holder
     {:class (if (:certified user)
               "avatar-certified"
               "avatar-not-certified")}
     (case (:type avatar)
       "icon"
       (let [initials (fu/user-initials (:name user))]
         [:span.new-avatar-icon
          {:class (if (:certified user)
                    "avatar-certified"
                    "avatar-not-certified")}
          initials])

       "image"
       [:img.new-avatar-image
        {:src (or (:url_medium avatar)
                  (:url avatar))}]

       "unassigned"
       (icons/unassigned-avatar)

       ;default
       "")]))

(defn user-collab-avatar
  ([user state]
   (user-collab-avatar user state nil))
  ([user state border-color]
   [tooltip/mux-tooltip
     {:position "top"}
     (:name user)
     (fn [props]
         [:div.collab-avatar-wrapper (merge props {})
          [:div.collab-avatar {:class (dom/classes-pairs "has-border" border-color)
                               :style (when border-color
                                        {"--collab-border-color" border-color})}
           [user-avatar2 user]]
         [:div.state-icon
          (if (= state "active")
            [:span.active
             [icons/online-circle-icon]]
            [:span.idle
             [icons/offline-circle-icon]])]])]))

(defn certification-modal [container-ref modal-open?]
  [modal/bootstrap-modal
    {:is-open?         @modal-open?
     :on-request-close #(reset! modal-open? false)
     :close-button?    true
     :container-ref   container-ref
     :centered?        true}
    [:div {:class "certified-header"}
      (get-translation "navigation.help-menu.get-certified.header" "Get Me Certified")]
    [:div {:class "certified-body"}
      [:p (get-translation "navigation.help-menu.get-certified.body_1" "The certification process is managed on the PractiTest Academy external application.")]
      [:p (get-translation "navigation.help-menu.get-certified.body_2" "If this is your first time, click ”Sign Up” to receive a registration email.")]
      [:p (get-translation "navigation.help-menu.get-certified.body_3" "Already registered? Click “Go to Academy”")]]
    [:div {:style {:display "flex" :gap "20px"}}
     [buttons/button {:primary? true
                      :size "large"
                      :on-click (fn []
                                  (mixpanel/track "Academy"))
                      ;; added classes to support in old ui
                      :class "m-button m-primary-button m-button-border"
                      :href broutes/help-menu-get-certified-url
                      :text (get-translation "navigation.help-menu.get-certified.go_to_academy" "Go to Academy")}]
     [buttons/button {:primary? true
                      :size "large"
                      :on-click (fn []
                                  (mixpanel/track "Sign Up to LMS")
                                  (re-frame/dispatch [::events/add-lms-participant])
                                  (reset! modal-open? false))
                      ;; added classes to support in old ui
                      :class "m-button m-primary-button m-button-border"
                      :text (get-translation "navigation.help-menu.get-certified.signup" "Sign Up")}]]]
)

(defn account-level-menu [options]
  (let [root-ref              (atom nil)
        main-menu-ref         (atom nil)
        submenu-overlay-state (reagent/atom {})
        modal-open?           (reagent/atom false)]
    (fn [{:keys [webcomponent?] :as options}]
      [:div.left-side
       {:class (dom/classes-pairs :webcomponent webcomponent?)
        :ref   (dom/root-ref-handler root-ref)}

       [tooltip/mux-tooltip
        {:position "right"}
        "PractiTest"
        (fn [props]
          [:a.pt-logo
           (assoc props
                  :id   "account-menu-logo"
                  :href (str "/?account_id=" (:id (:current-account options))))
           [icons/mux-practi-logo-small]])]

       [:<>
        [account-menu-item {:text        (get-translation "navigation.account-menu.all-projects" "All Projects")
                            :href        "/"
                            :id          "account-menu-all-projects"
                            :icon        [icons/mux-house]
                            :active?     (str/ends-with? (dom/get-current-path) "/landing")
                            :bottom-text false}]

        ;; Disabled for now, pending feature flag
        #_[account-menu-item {:text    "My Tasks"
                              :icon    [icons/mux-circle-checkbox]
                              :active? false}]

        [certification-modal root-ref modal-open?]
        [:div.account-menu-icons-holder
         ;; Disabled for now, pending feature flag
         #_[:div.account-menu-icon
            [icons/mux-bell]]

         (let [hide! (fn []
                       (swap! submenu-overlay-state assoc :show-help-menu? false))
               toggle! (fn []
                         (swap! submenu-overlay-state update :show-help-menu? not))
               show? (:show-help-menu? @submenu-overlay-state)]
           [overlay2/floating-ui-overlay
            {:placement        "right-end"
             :offset           5
             :on-request-close hide!
             :show?            show?}

            [tooltip/mux-tooltip
             {:position "right"}
             (get-translation "navigation.help-menu.help" "Help")
             (fn [props]
               [:div.account-menu-icon
                (-> props
                    (dom/add-test-id-and-id "account-menu-help")
                    (assoc :on-click (fn [_]
                                       (toggle!))))
                [:div.icon-tooltip-spacer
                 [icons/mux-circle-question-mark]]])]

            [:div.menu-popup
             [menu-item-element {:text        (get-translation "navigation.help-menu.help-center" "Help Center")
                                 :id          "help-menu-help-center"
                                 :href        broutes/help-menu-help-center-url
                                 :new-window? true
                                 :mixpanel    ["Question mark - help center"]
                                 :icon        icons/mux-information-ask}]
             [menu-item-element {:text        (get-translation "navigation.help-menu.discussion-forums" "Discussion Forums")
                                 :id          "help-menu-discussions-forums"
                                 :href        broutes/help-menu-discussions-forum-url
                                 :new-window? true
                                 :mixpanel    ["Question mark - discussion forums"]
                                 :icon        icons/mux-discussion-icon}]
             [menu-item-element {:text     (get-translation "navigation.help-menu.tutorials" "Tutorials")
                                 :id       "help-menu-tutorials"
                                 :href     (broutes/get-url "tutorials#index")
                                 :mixpanel ["Question mark - tutorials"]
                                 :icon     icons/mux-tutorials}]
             [menu-item-element {:text        (get-translation "navigation.help-menu.feature-request" "Feature Request")
                                 :id          "help-menu-feature-request"
                                 :href        broutes/help-menu-feature-request-url
                                 :new-window? true
                                 :mixpanel    ["Question mark - feature request"]
                                 :icon        icons/mux-letter}]
             [menu-item-element {:text        (get-translation "navigation.help-menu.get-certified" "Get Certified!")
                                 :id          "help-menu-get-certified"
                                 :on-click    (fn [_]
                                                (reset! modal-open? true))
                                 :mixpanel    ["Question mark - get certified"]
                                 :icon        icons/mux-certification}]]])

         (let [user-accounts (:user-accounts options)
               current-account (:current-account options)
               current-user-account (first (filter #(= (:id (:account %))
                                                       (:id current-account))
                                                   user-accounts))]
           (when (:is_owner current-user-account)
             [tooltip/mux-tooltip
              {:position "right"}
              (get-translation "navigation.settings-menu.tooltip" "Settings")
              (fn [props]
                [:a.account-menu-icon
                 (-> props
                     (assoc :href (broutes/get-url "account/accounts#settings" {:account_id (:id current-account)}))
                     (dom/add-test-id-and-id "account-menu-settings"))
                 [:div.icon-tooltip-spacer
                  [icons/mux-gear]]])]))

         ;; Account menu
         (let [user-accounts (:user-accounts options)
               current-user (:current-user options)
               current-account (:current-account options)
               current-project (:current-project options)
               single-account? (= 1 (count user-accounts))

               hide! (fn []
                       (swap! submenu-overlay-state assoc :show-account-menu? false))
               toggle! (fn []
                         (swap! submenu-overlay-state update :show-account-menu? not))
               show? (:show-account-menu? @submenu-overlay-state)]
           [overlay2/floating-ui-overlay
            {:placement        "right-end"
             :offset           10
             :show?            show?
             ;:trace?           true
             :on-request-close hide!}
            ;; Target
            [tooltip/mux-tooltip
             {:position "right"}
             (:name current-user)
             (fn [props]
               [:div.account-menu-avatar
                (assoc props
                  :id "account-menu-avatar"
                  :on-click (fn [_]
                              (toggle!)))

                [:div.avatar-and-badge-container
                 (when (:certified current-user)
                   [:div.badge-with-straps
                    [icons/mux-certified-badge-with-straps]])
                 [user-avatar2 current-user]]])]

            ;; Body
            [:div.menu-popup
             {:class (dom/classes-pairs :expanded-to-right (:show-account-submenu? @submenu-overlay-state))
              ;; Store ref to reuse it later
              :ref   (fn [node]
                       (when node
                         (reset! main-menu-ref node)))}

             (if single-account?
               [:<>
                [menu-item-element {:text       (:name current-account)
                                    :read-only? true
                                    :primary?   true
                                    :icon       icons/mux-circle-user}]
                [menu-item-separator {:class "single-account-separator"}]]

               (let [hide! (fn []
                             (swap! submenu-overlay-state assoc :show-account-submenu? false))
                     toggle! (fn []
                               (swap! submenu-overlay-state update :show-account-submenu? not))
                     show? (:show-account-submenu? @submenu-overlay-state)]
                 [menu-item-element {:text            "Switch Account"
                                     :id              "account-menu-switch-account"
                                     :on-click        (fn [e]
                                                        (toggle!)
                                                        ;; When click is not from our submenu (react propagates events
                                                        ;; even if child is actually rendered in portal)
                                                        (when-not (gobj/get e "_from_submenu")
                                                          ;; Otherwise it would hide everything
                                                          (dom/stop-propagation e)))
                                     ;; nested overlay
                                     :additional-item [overlay2/floating-ui-overlay
                                                       {:placement        (if (> (count user-accounts) 4)
                                                                            "right-end"
                                                                            "right-start")
                                                        :target           main-menu-ref
                                                        ;; Rendering into portal, otherwise there would be some
                                                        ;; interesting visual effects
                                                        :container        root-ref
                                                        :show?            show?
                                                        :on-request-close hide!}
                                                       ;; Target
                                                       [:span.dropdown-chevron
                                                        (if show?
                                                          [icons/mux-chevron-up2]
                                                          [icons/mux-chevron-down2])]
                                                       ;; Body
                                                       [:div.menu-popup
                                                        {:class (dom/classes-pairs :expanded-from-left true)}
                                                        (for [user-account user-accounts
                                                              :let [account (:account user-account)
                                                                    current? (= (:id account)
                                                                                (:id current-account))
                                                                    href (broutes/get-url "sessions#change_account_to_landing"
                                                                                          {}
                                                                                          {:account_id (:id account)})]]
                                                          ^{:key (:id account)}
                                                          [menu-item-element {:text            (:name account)
                                                                              :mixpanel        ["Switch Account"]
                                                                              :active?         current?
                                                                              :additional-item (when current?
                                                                                                 [:span.active-icon
                                                                                                  [icons/mux-checkbox]])
                                                                              :on-click        (fn [e]
                                                                                                 ;; We want to close parent menu too when
                                                                                                 ;; clicking on this item here. Will be propagated to parent handler
                                                                                                 (gobj/set e "_from_submenu" true))
                                                                              :href            href}])]]
                                     :icon            icons/mux-circle-user}]))
             [menu-item-element {:text (get-translation "navigation.settings-menu.personal-settings" "Personal settings")
                                 :id   "account-menu-personal-settings"
                                 :href (broutes/get-url "personals#index")
                                 :icon icons/mux-gear-cutout}]
             [menu-item-element {:text (get-translation "navigation.settings-menu.logout" "Logout")
                                 :id   "account-menu-logout"
                                 :href (broutes/get-url "sessions#destroy")
                                 :icon icons/mux-door-exit}]]])]]])))

(defn header-bar
  [options]
  (reagent/with-let [search-box-ref (atom nil)]
    [:div.header-bar
     [keyboard-shortcuts/add-shortcut
      {:shortcut [:global :focus-on-search]
       :handler (fn [] (dom/focus-on-ref! search-box-ref false))}]
     [project-selector
      (select-keys options
                   [:current-project
                    :current-account
                    :user-projects
                    :webcomponent?
                    :on-project-pin-clicked])]
     [search-box/search-box-component options search-box-ref]]))

(defn current-path-includes? [uri]
  (str/starts-with? (dom/get-current-path) uri))

(re-frame/reg-sub
  ::state
  (fn [db]
    (::state db)))

(defn project-level-menu-collapsed?
  [db]
  (get-in db [::state :project-level-menu-collapsed?]))

(defn set-project-level-menu-collapsed
  [db value]
  (assoc-in db [::state :project-level-menu-collapsed?] value))

(re-frame/reg-sub
  ::project-level-menu-collapsed?
  :<- [::state]
  (fn [state]
    (:project-level-menu-collapsed? state)))

(re-frame/reg-event-db
  ::collapse-project-level-menu
  (fn [db]
    (dom/set-item "nav-ui-project-collapsed" true)
    (set-project-level-menu-collapsed db true)))

(re-frame/reg-event-db
  ::set-project-level-menu-collapsed?
  (fn [db [_ value]]
    (dom/set-item "nav-ui-project-collapsed" value)
    (set-project-level-menu-collapsed db value)))

(defn load-project-level-state!
  []
  (let [v (dom/get-item "nav-ui-project-collapsed")]
    (if (string? v)
      (re-frame/dispatch-sync [::set-project-level-menu-collapsed? (parse-boolean v)])
      false)))

(development-only
  (defn portal-icon []
    [:svg {:version "1.1" :width "16" :height "16" :viewBox "0 0 16 16" :xmlns "http://www.w3.org/2000/svg" :xmlns:cc "http://creativecommons.org/ns#" :xmlns:dc "http://purl.org/dc/elements/1.1/" :xmlns:rdf "http://www.w3.org/1999/02/22-rdf-syntax-ns#"}
     [:metadata
      [:rdf:rdf
       [:cc:work {:rdf:about ""}
        [:dc:format "image/svg+xml"]
        [:dc:type {:rdf:resource "http://purl.org/dc/dcmitype/StillImage"}]
        [:dc:title]]]]
     [:g {:transform "translate(-61.551 -61.543)"}
      [:path {:d              "m68.221 62.059-0.93776 0.93795-0.93783 0.93795h2.3586c1.4792 0 2.4195 0.0047 2.522 0.01285 0.53807 0.04233 0.97164 0.13826 1.4114 0.31225 0.51316 0.20303 0.91048 0.45759 1.2525 0.80239 0.41727 0.42071 0.6414 0.78548 0.82678 1.3454 0.16475 0.49768 0.23209 0.91946 0.2313 1.4495-7.6e-4 0.51573-0.06235 0.92107-0.21977 1.4469-0.32005 1.0691-0.99473 1.8238-2.0587 2.3032-0.36998 0.16667-0.77605 0.27266-1.2757 0.33294-0.16412 0.0198-0.40861 0.02263-2.5137 0.0289-2.2436 0.0067-2.3336 0.0079-2.3763 0.0306-0.06182 0.03293-0.11238 0.08261-0.13725 0.13481-0.01947 0.04087-0.02139 0.23547-0.02445 2.4681l-0.0033 2.4238h4.5437l6.1532-6.1532-0.0033-4.068-0.0033-4.0681-0.03474-0.10233c-0.08518-0.25118-0.27684-0.44366-0.52958-0.53183l-0.1074-0.03749-4.0681-0.0033zm-4.1695 4.1695-0.99187 0.992-0.99181 0.99206 0.0033 4.068 0.0033 4.068 0.02965 0.08872c0.09766 0.29236 0.33201 0.50831 0.61673 0.56845 0.07088 0.01497 0.21282 0.01899 0.70627 0.01981l0.61755 1e-3 0.0039-2.7976c0.0042-3.0461 4e-6 -2.8604 0.07286-3.1701 0.18211-0.77412 0.62524-1.1449 1.5115-1.2648 0.13832-0.01871 0.44271-0.0218 2.8417-0.02896l2.6868-8e-3 0.12672-0.02872c0.5266-0.11925 0.90743-0.40034 1.1281-0.83274 0.06294-0.12334 0.14526-0.36337 0.17569-0.51233 0.10306-0.5045 0.01371-1.0283-0.24215-1.4194-0.23095-0.35306-0.50759-0.55861-0.88704-0.65924-0.27232-0.07221-0.01273-0.06743-3.8689-0.07197z"
              :fill           "#2588BF"
              :stroke         "#050e1e"
              :stroke-linecap "round" :stroke-linejoin "round" :stroke-width ".032103"}]]])

  (defn wrench-icon []
    [:svg.bi.bi-wrench-adjustable {:xmlns "http://www.w3.org/2000/svg" :width "16" :height "16" :fill "currentColor" :viewBox "0 0 16 16"}
     [:path {:d "M16 4.5a4.5 4.5 0 0 1-1.703 3.526L13 5l2.959-1.11q.04.3.041.61"}]
     [:path {:d "M11.5 9c.653 0 1.273-.139 1.833-.39L12 5.5 11 3l3.826-1.53A4.5 4.5 0 0 0 7.29 6.092l-6.116 5.096a2.583 2.583 0 1 0 3.638 3.638L9.908 8.71A4.5 4.5 0 0 0 11.5 9m-1.292-4.361-.596.893.809-.27a.25.25 0 0 1 .287.377l-.596.893.809-.27.158.475-1.5.5a.25.25 0 0 1-.287-.376l.596-.893-.809.27a.25.25 0 0 1-.287-.377l.596-.893-.809.27-.158-.475 1.5-.5a.25.25 0 0 1 .287.376M3 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2"}]])

  (defn developer-section
    [collapsed?]
    [:<>
     [:div.menu-spacer]

     [menu-item-header {:text       "Developers Section"
                        :icon       wrench-icon
                        :collapsed? collapsed?}]


     [menu-item-element {:text       "Open Portal"
                         :id         "dev-menu-open-portal"
                         :icon       portal-icon
                         :collapsed? collapsed?


                         :on-click   (fn [e]
                                       ;; Tap DB by default
                                       (tap> re-frame.db/app-db)
                                       (if-let [portal-open (resolve 'portal.web/open)]
                                         (portal-open)
                                         (js/alert "No portal API is available - check your configuration")))}]

     [menu-item-element {:text       "Sandbox"
                         :id         "dev-menu-sandbox"
                         :icon       icons/svg-code-slash
                         :collapsed? collapsed?
                         :href       "/dev"}]

     [menu-item-element {:text       "All Icons"
                         :id         "dev-menu-icons"
                         :icon       icons/mux-info-circle-nofill
                         :collapsed? collapsed?
                         :href       "/dev/icons"}]

     [menu-item-element {:text       "DNDKit Sandbox"
                         :id         "dev-dndkit-sandbox"
                         :icon       icons/mux-drag-handle
                         :collapsed? collapsed?
                         :href       "/dev/dndkit"}]
     ]))

;; TODO: integrate with router and old UI
(defn project-level-menu
  [options]
  ;; Initializer
  (load-project-level-state!)

  (fn [{:keys [webcomponent? current-project user-projects] :as props}]
    (let [collapsed? @(re-frame/subscribe [::project-level-menu-collapsed?])
          ;; Need here for forced redraw when route changes during client-side navigation
          ;; otherwise active element is not updated
          current-route @(re-frame/subscribe [::router/current-route])]
      [:div.project-level-menu
       {:class (dom/classes-pairs :collapsed collapsed?
                                  :webcomponent webcomponent?)}
       [menu-item-header {:text       (get-translation "navigation.project-menu.main-modules" "Main Modules")
                          :icon       icons/mux-union
                          :collapsed? collapsed?}]
       (let [uri (broutes/get-url-view "milestones#index")]
         (when (permissions/has-permission? "milestones_view")
           [menu-item-element {:text       (get-translation "navigation.project-menu.milestones" "Milestones")
                               :id         "project-menu-milestones"
                               :test-id    "project-menu-milestones"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-milestones
                               :collapsed? collapsed?}]))
       (let [uri (broutes/get-url-view "requirements#index")]
         (when (permissions/has-permission? "requirements_view")
           [menu-item-element {:text       (get-translation "navigation.project-menu.requirements" "Requirements")
                               :id         "project-menu-requirements"
                               :test-id    "project-menu-requirements"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-requirements
                               :collapsed? collapsed?}]))
       (let [uri (broutes/get-url-view "qtest_designs#index")]
         (when (permissions/has-permission? "tests_runs_view")
           [menu-item-element {:text       (get-translation "navigation.project-menu.test-library" "Test Library")
                               :id         "project-menu-test-library"
                               :test-id    "project-menu-test-library"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-test-library
                               :collapsed? collapsed?}]))
       (let [uri (broutes/get-url-view "suites#index")]
         (when (permissions/has-permission? "tests_runs_view")
           [menu-item-element {:text       (get-translation "navigation.project-menu.testsets" "Test Sets & Runs")
                               :id         "project-menu-testsets"
                               :test-id    "project-menu-testsets"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-testsets-runs
                               :collapsed? collapsed?}]))
       (let [uri (broutes/get-url-view "issues#index")]
         (when (permissions/has-permission? "issues_view")
           [menu-item-element {:text       (get-translation "navigation.project-menu.issues" "Issues")
                               :id         "project-menu-issues"
                               :test-id    "project-menu-issues"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-issues
                               :collapsed? collapsed?}]))

       [:div.menu-spacer]

       ;; TODO: spacer or just increase margin-bottom ?
       [menu-item-header {:text       (get-translation "navigation.project-menu.project-info" "Project Info")
                          :icon       icons/mux-project-info
                          :collapsed? collapsed?}]

       (let [uri (broutes/get-url-view "summary#index")]
         [menu-item-element {:text       (get-translation "navigation.project-menu.dashboards" "Dashboards")
                             :id         "project-menu-dashboards"
                             :test-id    "project-menu-dashboards"
                             :href       uri
                             :active?    (current-path-includes? uri)
                             :icon       icons/mux-dashboards
                             :collapsed? collapsed?}])
       (let [uri (broutes/get-url-view "kanban#index")]
         [menu-item-element {:text       (get-translation "navigation.project-menu.taskboard" "Task Board")
                             :id         "project-menu-taskboard"
                             :test-id    "project-menu-taskboard"
                             :href       uri
                             :active?    (current-path-includes? uri)
                             :icon       icons/mux-taskboard
                             :collapsed? collapsed?}])
       (let [uri (broutes/get-url-view "reports#index")]
         (when (permissions/has-permission? "reports")
           [menu-item-element {:text       (get-translation "navigation.project-menu.reports" "Reports")
                               :id         "project-menu-reports"
                               :test-id    "project-menu-reports"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-reports
                               :collapsed? collapsed?}]))
       (let [uri (broutes/get-url-view "histories#index" {:project_id (:id current-project)})]
         ;; TODO: why it's called users_n_per ??
         (when (permissions/has-permission? "users_n_per")
           [menu-item-element {:text       (get-translation "navigation.project-menu.project-history" "Project History")
                               :id         "project-menu-project-history"
                               :test-id    "project-menu-project-history"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-project-history
                               :collapsed? collapsed?}]))
       (if (permissions/has-permission? "users_n_per")
         (let [uri (broutes/get-url-view "projects#edit" {:id (:id current-project)})]
           [menu-item-element {:text       (get-translation "navigation.project-menu.project-settings" "Project Settings")
                               :id         "project-menu-project-settings"
                               :test-id    "project-menu-project-settings"
                               :href       uri
                               ;; TODO: fix this - right now I'm enumerating all possible tab uris
                               :active?    (let [project-base-uri (str "/projects/" (:id current-project))
                                                 project-base-uri2 (str "/p/" (:id current-project))
                                                 available-urls #{(str project-base-uri "/edit")
                                                                  (str project-base-uri2 "/edit")
                                                                  (str project-base-uri "/automation")
                                                                  (str project-base-uri "/integration_settings")
                                                                  (str project-base-uri "/custom_views")
                                                                  (str project-base-uri "/custom_fields")
                                                                  (str project-base-uri "/step_params")
                                                                  (str project-base-uri "/workflow_editor")
                                                                  (str project-base-uri2 "/dashboards")
                                                                  (str project-base-uri "/groups")
                                                                  (str project-base-uri "/import")}]
                                             (contains? available-urls (str/lower-case (dom/get-current-path))))
                               :icon       icons/mux-project-settings
                               :collapsed? collapsed?}])
         ;; For Testers - different uri
         (let [uri (broutes/get-url-view "custom_views#index")]
           [menu-item-element {:text       (get-translation "navigation.project-menu.project-settings" "Project Settings")
                               :id         "project-menu-project-settings"
                               :test-id    "project-menu-project-settings"
                               :href       uri
                               :active?    (current-path-includes? uri)
                               :icon       icons/mux-project-settings
                               :collapsed? collapsed?}]))

       (development-only
         [developer-section collapsed?])

       [:div.close-button
        (-> {:class (dom/classes-pairs :collapsed collapsed?)
             :on-click (fn []
                         (re-frame/dispatch [::set-project-level-menu-collapsed? (not collapsed?)]))}
            (dom/add-test-id "project-menu-close-btn"))
        (when-not collapsed?
          [:span "Close"])
        [:div.arrow-close
         (if collapsed?
           [icons/mux-arrow-right]
           [icons/mux-arrow-left])]]])))

(defmulti system-message (fn [_ {:keys [message_type]}]
                           (case message_type
                             ("normal" "expiration_msg" "jira_s_config" "disable_redmine") :normal
                             ("non_owner_demo" "owner_demo") :demo
                             ("exceeding") :danger
                             ("non_clossable") :non_clossable
                             :wtf)))

(defmethod system-message :normal [dismiss-message! {:keys [id message hide-uri]}]
  [:div.alert.alert-dismissible.alert-info.fade.show.mt-0.mb-0
   {:role "alert" :id (str "alert-" id)}
   [:span {:dangerouslySetInnerHTML {:__html message}}]
   [:button.btn-close
    {:type "button"
     :aria-label "Close"
     ;; have no idea why it doesn't work, guess because we use react-bootstrap
     ;; anyway, implementing poor man's dismiss is not a big deal
     ;; and we need to refactor the system messages (once MouseUX will have the design for it) anyway
     :data-bs-dismiss (str "alert-" id)
     :on-click (fn [_]
                 (dismiss-message! id hide-uri))}]])

(defmethod system-message :demo [_ {:keys [message]}]
  [:div.alert.alert-warning.mt-0.mb-0
   {:role "alert"}
   [:span {:dangerouslySetInnerHTML {:__html message}}]])

(defmethod system-message :danger [_ {:keys [message]}]
  [:div.alert.alert-danger.mt-0.mb-0
   {:role "alert"}
   [:span {:dangerouslySetInnerHTML {:__html message}}]])

(defmethod system-message :non_clossable [_ {:keys [message]}]
  [:div.alert.alert-info.mt-0.mb-0
   {:role "alert"}
   [:span {:dangerouslySetInnerHTML {:__html message}}]])

(defmethod system-message :default [message]
  [:div.alert.alert-error (pr-str message)])

(defn system-messages-bar [{:keys [system-messages on-hide-system-message webcomponent? current-user-account]}]
  (let [state (reagent/atom (->> system-messages
                                 (map (juxt :id identity))
                                 (into {})))
        dismiss-message! (fn [id uri]
                           (swap! state dissoc id)
                           (on-hide-system-message id uri))]
    (fn [props]
      (let [messages (vals @state)
            user-account (or current-user-account (:current-user-account props))
            filtered-messages (let [excluded (if (:is_owner user-account) "non_owner_demo" "owner_demo")] 
                                (remove #(= (:message_type %) excluded) messages))]
            
      (when (seq filtered-messages)
          (into [:div.system-messages
                 {:class (dom/classes-pairs-v :webcomponent webcomponent?)}]
                (for [message filtered-messages]
                  [system-message dismiss-message! message])))))))

  (defn navigation-layout
    [body options]
    [:div.main-window
     [notifications/toast-container]
     [account-level-menu options]

     [:div.right-side
      [system-messages-bar (assoc options :current-user-account (some #(when (= (:id (:account %)) (:id (:current-account options))) %) (:user-accounts options)))]
      [header-bar options]

      [:div.menu-and-body-container
       [project-level-menu options]

       [:div.main-body
        body]]]])
